import React from 'react';
import FemaleIcon from '@mui/icons-material/Female';
import MaleIcon from '@mui/icons-material/Male';

import styles from '../style.module.css';
import { Divider, Stack, Typography } from '@mui/material';
import { Handle, Position } from '@xyflow/react';

export const HouseNode = React.memo(({ id, data }) => (
  <div className={styles.houseNode}>
    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative', width: '97%' }}>
      <Handle
        type="target"
        position={Position.Top}
        id={'target-house-edge'}
        style={{ background: '#008f37', marginLeft: '6px' }}
        isConnectable={true}
      />
      <Handle
        type="source"
        position={Position.Top}
        id={'source-house-edge'}
        style={{ background: '#0073e6', marginRight: '0px' }}
        isConnectable={true}
      />
    </div>

    <Stack direction="row" alignItems="center" justifyContent="center">
      {data.preferredGender === 'boy' ? (
        <MaleIcon sx={{ width: 12, height: 12 }} />
      ) : data.preferredGender === 'girl' ? (
        <FemaleIcon sx={{ width: 12, height: 12 }} />
      ) : null}
      <Typography align="center" fontSize="12px" fontWeight="bold">
        {data?.label} {data.preferredAge && data.preferredAge !== 'brak' && `- ${data.preferredAge} lat`}
      </Typography>
    </Stack>

    <Divider />
  </div>
), (prevProps, nextProps) => prevProps.data.label === nextProps.data.label &&
  prevProps.data.preferredGender === nextProps.data.preferredGender &&
  prevProps.data.preferredAge === nextProps.data.preferredAge
);
